/**
 * QR 추적 파라미터.
 *
 * "TV 화면에서 본 상품이 실제 구매로 이어졌는가"를 측정하는 유일한 수단이며,
 * 이 MVP 가 증명해야 할 사업 지표다. 리시버(QR 생성)와 서버(랜딩 페이지 로깅)가
 * 같은 이름을 써야 하므로 여기에 둔다.
 *
 *     {deepLink}?src=fast&d={deviceId}&p={productId}&pl={playlistId}
 */
export const TRACKING_PARAMS = {
    source: 'src',
    deviceId: 'd',
    productId: 'p',
    playlistId: 'pl',
};
export const TRACKING_SOURCE_FAST = 'fast';
/**
 * 딥링크에 추적 파라미터를 붙인다. 기존 쿼리스트링과 프래그먼트를 보존한다.
 *
 * `URL` 을 쓰지 않는 이유: 이 패키지는 DOM 도 Node 도 없는 `lib: ES2022` 로 컴파일된다.
 * 계약 타입이 플랫폼에 묶이면 SDK 코어 이식성 근거가 무너진다.
 */
export function buildTrackingUrl(deepLink, ctx) {
    const hashAt = deepLink.indexOf('#');
    const base = hashAt === -1 ? deepLink : deepLink.slice(0, hashAt);
    const fragment = hashAt === -1 ? '' : deepLink.slice(hashAt);
    const query = [
        [TRACKING_PARAMS.source, TRACKING_SOURCE_FAST],
        [TRACKING_PARAMS.deviceId, ctx.deviceId],
        [TRACKING_PARAMS.productId, ctx.productId],
        [TRACKING_PARAMS.playlistId, ctx.playlistId],
    ]
        .map(([key, value]) => `${key}=${encodeURIComponent(value ?? '')}`)
        .join('&');
    const separator = base.includes('?') ? '&' : '?';
    return `${base}${separator}${query}${fragment}`;
}
//# sourceMappingURL=tracking.js.map